/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdLangsCulture200,
  GetApiV1ClassroomdisciplineIdLangsCulture401,
  GetApiV1ClassroomdisciplineIdLangsCulture404,
  GetApiV1ClassroomdisciplineIdLangsCulturePathParams,
  GetApiV1ClassroomdisciplineIdLangsCultureQueryResponse,
} from "../../types/classPlanningLangController/GetApiV1ClassroomdisciplineIdLangsCulture.ts";
import { classroomDisciplineLangItemViewModelSchema } from "../classroomDisciplineLangItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdLangsCulturePathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    culture: z.string(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangsCulturePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdLangsCulture200Schema = z.lazy(
  () => classroomDisciplineLangItemViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangsCulture200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdLangsCulture401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangsCulture401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdLangsCulture404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangsCulture404>;

export const getApiV1ClassroomdisciplineIdLangsCultureQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdLangsCulture200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdLangsCultureQueryResponse>;
